import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import styles from './styles.scss'

import Dropdown from 'components/form/dropdown'
import { projectWorkflowTransitionsSelector } from '../selectors'

import SubmitButton from './SubmitButton'

import { LIFECYCLE_STATES } from '../constants'
const mapStateToProps = state => {
    return {
        stateOptions: projectWorkflowTransitionsSelector(state)
    }
}

const mapDispatchToProps = state => {
    return {}
}

class LifecycleTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            lifecycle: ""
        }
    }

    onLifecycleChange = (select) => this.setState({ lifecycle: select })
    cancelState = () => this.setState({ lifecycle: "" })
    render() {
        return (
            <div>
                <SubmitButton numberOfProjects={this.props.numberOfProjects} cancelState={this.cancelState} formDetails={this.state} formType="lifecycle" />
            <div styleName='lifecycleEditContainer'>
                <Dropdown
                    className={styles.example}
                    title='Select state to transition to'
                    defaultValue='Select State'
                    source={LIFECYCLE_STATES}
                    value={this.state.lifecycle}
                    onChange={this.onLifecycleChange}
                    auto
                    />
            </div>
            </div>
        )
    }
}
const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)

const enhance = compose(
    withConnect,
    withStyle
)

export default enhance(LifecycleTab)